import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 px-4 sm:px-6 lg:px-8 bg-zinc-900/20 border-y border-zinc-800/30 relative overflow-hidden" data-id="element-8">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[1px] bg-gradient-to-r from-transparent via-amber-500/20 to-transparent" data-id="element-9"></div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[1px] bg-gradient-to-r from-transparent via-amber-500/20 to-transparent" data-id="element-10"></div>

      <div className="max-w-4xl mx-auto relative" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center" data-id="element-12">
          <div className="flex justify-center mb-8" data-id="element-13">
            <Quote className="w-16 h-16 text-amber-500/20 rotate-180" data-id="element-14" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-10 flex items-center justify-center gap-6 text-zinc-100" data-id="element-15">
            <span className="w-16 h-[1px] bg-gradient-to-r from-transparent to-amber-500/50" data-id="element-16"></span>
            Professional Overview
            <span className="w-16 h-[1px] bg-gradient-to-l from-transparent to-amber-500/50" data-id="element-17"></span>
          </h2>

          <p className="text-xl md:text-2xl leading-relaxed text-zinc-300 font-serif font-light italic mb-8" data-id="element-18">
            "Serving the communication needs of Uttar Pradesh's highest office
            with precision, strategic foresight, and an unwavering commitment to
            public narrative."
          </p>

          <p className="text-lg leading-relaxed text-zinc-400 font-sans max-w-3xl mx-auto" data-id="element-19">
            With a distinguished career spanning over two decades, I bring deep
            expertise in media relations, narrative building, and strategic
            content creation. Currently serving as Manager - Content at the
            Chief Minister's Media Cell, I leverage{' '}
            <strong className="text-zinc-200 font-medium" data-id="element-20">
              21 years of experience in Electronic Media
            </strong>{' '}
            and{' '}
            <strong className="text-zinc-200 font-medium" data-id="element-21">
              7 years of specialized service in government media operations
            </strong>
            . My background as a Sr. Research Fellow with the Ministry of
            Culture, Government of India, further informs my analytical and
            culturally nuanced approach to public communication across Uttar
            Pradesh and the nation.
          </p>

          <div className="mt-12 flex justify-center" data-id="element-22">
            <div className="w-8 h-8 flex items-center justify-center" data-id="element-23">
              <div className="w-1.5 h-1.5 rounded-full bg-amber-500/50 mx-1" data-id="element-24"></div>
              <div className="w-2 h-2 rounded-full bg-amber-500 mx-1" data-id="element-25"></div>
              <div className="w-1.5 h-1.5 rounded-full bg-amber-500/50 mx-1" data-id="element-26"></div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}